var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('Robots'),_c('BottomNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }